import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ApiConnection } from '@definitions/apis';
import { catchError, Observable, of } from 'rxjs';
import { ApiConnectionsService } from '../../connections/services/api-connections.service';

export const apiConnectionResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<ApiConnection> => {
	const connectionsSvc = inject(ApiConnectionsService);
	const connectionId = route.paramMap.get('connectionId');

	return !isNaN(connectionId as any)
		? connectionsSvc.find(connectionId).pipe(catchError(() => of(null)))
		: of(null);
};
